exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#method-chart[data-v-23dcaeec] {\n  width: 650px;\n  height: 300px;\n}\n\n", ""]);

// exports
